import React, { useState } from 'react';
import cx from 'classnames';
import { useScrollbar } from './useScrollbar.js';
import styles from './index.module.scss.js';

const WithCustomScrollbar = ({
  className,
  style,
  children,
  updateKey,
  styleChildren
}) => {
  const [scrollableElement, setScrollableElement] = useState(null);
  const [wrapperElement, setWrapperElement] = useState(
    null
  );
  useScrollbar({ element: scrollableElement, wrapperElement, updateKey });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, "with-custom-scrollbar"),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: cx(styles.box__container), ref: setScrollableElement }, /* @__PURE__ */ React.createElement("div", { style: styleChildren, ref: setWrapperElement }, children))
  );
};
WithCustomScrollbar.displayName = "WithCustomScrollbar";

export { WithCustomScrollbar };
//# sourceMappingURL=index.js.map
